import React from "react";
import { Link, useLocation } from "react-router-dom";
import SignIn from "../Tuning/Pages/Authentication/SignIn";
import Signup from "../Tuning/Pages/Authentication/Signup";
import PasswordReset from "../Tuning/Pages/Authentication/PasswordReset";
import TwoStep from "../Tuning/Pages/Authentication/TwoStep";
import Lockscreen from "../Tuning/Pages/Authentication/Lockscreen";
import Maintenance from "../Tuning/Pages/Authentication/Maintenance";
import NoPageFound from "../Tuning/Pages/Authentication/NoPageFound";

const AuthLayout = () => {

    const location = useLocation();
    const pathname = location.pathname;

    // x---------------------------------x All Auth Mapping x---------------------------------x
    const authTitleMapping = {
        "/signin": "Signin",
        "/signup": "Signup",
        "/password-reset": "PasswordReset",
        "/two-step": "TwoStep",
        "/lockscreen": "Lockscreen",
        "/maintenance": "Maintenance",
        "/404": "NoPage",
    };

    // x---------------------------------x Auth Title Mapping x---------------------------------x
    const authTitle = authTitleMapping[pathname] || "";

    // x---------------------------------x All Auth Components x---------------------------------x
    const authComponents = {
        Signin: <SignIn />,
        Signup: <Signup />,
        PasswordReset: <PasswordReset />,
        TwoStep: <TwoStep />,
        Lockscreen: <Lockscreen />,
        Maintenance: <Maintenance />,
        NoPage: <NoPageFound />,
    };

    return (
        <div data-theme="theme-Bluelight" className="svgstroke-a auth">
            <main className="container justify-center items-center mx-auto w-full h-[100vh]">
                {/* x---------------------------------x Project Logo x---------------------------------x */}
                <div className="flex flex-col items-center justify-center gap-4">
                    {/* x---------------------------------x Header Section x---------------------------------x */}
                    <div className="w-full text-center auth-header flex justify-center">
                        <Link to="/" className="flex items-center no-underline" title="DashBanker Admin Template">
                            <svg
                                className="mr-2 text-blue-500"
                                width="40"
                                height="40"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M3 21h18" />
                                <path d="M3 10h18" />
                                <path d="M5 6l7-3 7 3" />
                                <path d="M4 10v11" />
                                <path d="M20 10v11" />
                                <path d="M8 14v3" />
                                <path d="M12 14v3" />
                                <path d="M16 14v3" />
                            </svg>
                            <span className="font-bold pl-2 text-2xl bg-gradient-to-r from-blue-500 to-purple-500 text-transparent bg-clip-text">DashBanker</span>
                        </Link>
                    </div>

                    {/* x---------------------------------x Page Body Area x---------------------------------x */}
                    <div className="lg:w-[30vw] w-[90vw] flex-grow">
                        {authComponents[authTitle]}
                    </div>

                    {/* x---------------------------------x Footer Section x---------------------------------x */}
                    <footer className="mt-3 text-center w-full">
                        <p className="mb-0 text-gray-500">
                            © 2024 <Link to="/" target="_blank" title="DashBanker" className="text-accent"> DashBanker</Link>, All Rights Reserved.
                        </p>
                    </footer>
                </div>
            </main>
        </div>
    );
};

export default AuthLayout;
